export default __webpack_public_path__ + "static/media/brawl-stars.444dd052.webp";